module.exports = __webpack_public_path__ + "img/img3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img3.jpg
// module id = 1296
// module chunks = 0